import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const TestimonialCard = ({ 
  quote, 
  authorTitle, 
  authorCompany, 
  sx = {}
}) => {
  return (
    <Paper elevation={0} sx={{
      p: 4,
      height: '100%',
      backgroundColor: 'grey.50',
      borderRadius: '16px',
      display: 'flex',
      flexDirection: 'column',
      ...sx
    }}>
      <Typography variant="body1" sx={{
        color: '#0A2540',
        fontSize: '1.1rem',
        lineHeight: 1.6,
        mb: 3,
        fontStyle: 'italic',
        flex: 1
      }}>
        "{quote}"
      </Typography>
      <Box>
        <Typography variant="subtitle2" sx={{ 
          fontWeight: 700, 
          color: '#1976d2', 
          mb: 0.5 
        }}>
          {authorTitle}
        </Typography>
        <Typography variant="body2" sx={{ color: '#546E7A' }}>
          {authorCompany}
        </Typography>
      </Box>
    </Paper>
  );
};

export default TestimonialCard; 